<template>
    <div class="deal_refund_box">
        <!-- 開發配置 -->
        <div class="deal_title">
            <div>開發配置</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- BOX-go -->
        <div>
            <!-- 内容-1-商家咨詢 -->
            <div class="deal_content_box">
                <div class="deal_content_title">商家咨詢</div>
                <div class="deal_content">
                   <div>
					   商家編號：<span>{{this.$store.state.uid}}</span>
				   </div>
                   <div>
					   商家名稱：<span>{{this.$store.state.principal}}</span>
				   </div>
                   <div>
					   商家簡稱：<span>{{this.$store.state.storename }}</span>
				   </div>
                </div>
            </div>
             <!-- 内容-2-支付設定 -->
            <div class="deal_content_box">
                <div class="deal_content_title">支付設定</div>
                <div class="deal_content set_box">
					<div>
						授權目錄
						<el-input v-model="catalogueInput" placeholder=""></el-input>
						<el-button type="primary" @click="addFun()">新增</el-button>
					</div>
					<!-- 表單 -->
					<div class="table_box">
						<div class="table_header">
							<p class="catalogue">
								API支付授權目錄（上限為5組）
							</p>
							<p class="operation">
								操作
							</p>
						</div>
						<div class="table_content" v-for="item in catalogueList" :key="item.id">
							<p class="catalogue">
								{{item.url}}
							</p>
							<p class="operation del_box" @click="delFun(item.id)">
								刪除<i class="el-icon-delete"></i>
							</p>
						</div>
					</div>
                </div>
            </div>
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LoginDealRefund',
    data() {
        return {
		   catalogueInput: '',
		   catalogueList: [],
        }
    },
    methods: {
        forget() {
            this.$router.push("/forget");
		},
        // FUN-添加
		addFun(){
			if(this.catalogueInput != ''){

				axios.get(this.$store.state.axiosAddCatalogueUrl, {
					params:{
						url: this.catalogueInput,
						uid: this.$store.state.uid,
					}
				}).then(res =>{
					// console.log(res.data);
					if(res.data.status){
						this.$message({
						showClose: true,
						message: res.data.message,
						type: 'success',
						duration: 1000
                        });
                        this.catalogueInput = '';
						this.createdFun();
					} else {
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error',
							duration: 1000
						});
					}
				})

			} else {
                this.$message({
                    showClose: true,
                    message: '授權目錄不能為空',
                    type: 'error',
                    duration: 1000
                });
            }
        },
        // FUN-删除
		delFun(id){
            axios.get(this.$store.state.axiosDelCatalogueUrl, {
				params:{
                    uid: this.$store.state.uid,
                    id:id
				}
			}).then(res =>{
                // console.log(res.data);
                this.$message({
                    showClose: true,
                    message: '刪除成功',
                    type: 'success',
                    duration: 1000
                });
                this.createdFun();
			})
		},
		// FUN-頁面加載執行
		createdFun(){
			axios.get(this.$store.state.axiosCatalogueUrl, {
				params:{
					uid: this.$store.state.uid
				}
			}).then(res =>{
				// console.log(res.data);
				this.catalogueList = res.data.message;
			})
		}
	},
	created() {
		this.createdFun();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 開發配置 */
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        cursor: pointer;
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 32px 36px;
    }
    .deal_content > div {
        margin: 22px 0;
		letter-spacing: 1px;
    }
	.set_box .el-input {
		width: 320px;
		margin-left: 10px;
	}
	/* 表單 */
	.table_box {
		max-width: 700px;
	}
	.table_box >div {
		display: flex;
		padding: 14px 17px;
	}
	.table_box .catalogue {
		flex: 3;
	}
	.table_box .operation {
		flex: 1;
	}
	.table_header {
		background: #f2f2f2;
	}
    .del_box {
        cursor: pointer;
    }

</style>
